import React, { useEffect, useState } from 'react';
import CanvasJSReact from '../../../assets/canvasjs.react';
import { getPerfectDate, getPerfectDateTime, getPerfectDateTimeWithHours, convertTimezone } from '../../../utils';
import { useTranslation } from 'react-i18next';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ChartRPMonth = ({data}) =>  {
  const {t} = useTranslation(['widgets']);
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!data) {
      return;
    }
    const itemData = [];
    data.forEach(it => {
      itemData.push({
        x: new Date(it.at + convertTimezone(it.at)),
        y: it.sum ? (it.sum > 0 ? ((it.sum / it.seconds / 1000) * (it.seconds / 3600)) : 0) : 0  
      })
    });

    setChartData(itemData);
    setLoading(false);
  }, [data]);

  const baseOptions = {
    animationEnabled: true,
    zoomEnabled: true,
    height: 200,
    culture:  "ru",
    toolTip: {
			shared: true,
      fontFamily: "helvetica, arial",
      cornerRadius: 2,
      borderThickness: 0,
			contentFormatter: function (e) {
				var content = " ";
				for (var i = 0; i < e.entries.length; i++) {
          content += "<div class='p-2'>";
          content += getPerfectDate(e.entries[i].dataPoint.x);
          content += "<br/>";
					content += t('rp') + " " + "<strong>" + e.entries[i].dataPoint.y.toFixed(2) + "</strong>";
          content += "</div>";
				}
				return content;
			}
		},
    axisX:{
      lineColor: '#E7ECF8',
      intervalType: "day",
      valueFormatString: 'DD',
      labelFontFamily: "helvetica, arial",
      labelFontColor: '#444444',
      labelFontSize: 10,
    },
    axisY: {
      includeZero: true,
      lineColor: 'transparent',
      gridDashType: 'dash',
      gridColor: '#E7ECF8',
      labelFontFamily: "helvetica, arial",
      labelFontColor: '#444444',
      labelFontSize: 10,
      labelPlacement:"inside",
    },
  };

  const options = {
    data: [{
      yValueFormatString: "####0.##",
      indexLabel: "{y}",
      indexLabelFontFamily: "helvetica, arial",
      indexLabelFontColor: "#fb8500",
      indexLabelPlacement: "inside",
      xValueFormatString: "HH:mm",
      type: "column",
      color: '#424874',
      fillOpacity: 1,
      lineColor: '#424874',
      lineThickness: 1,
      markerType: "circle",
      markerSize: 0,
      dataPoints: chartData
    }]
  };



  return (
    <div className="my-4 border-t">
      <div className="flex items-center h-10">
        <span>{t('rp')}</span>
      </div>
      <div className="text-sm">
        <CanvasJSChart options = {{...baseOptions, ...options}}/>
      </div>
    </div>
  );
}

export default ChartRPMonth;